import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  private num1: number = 0;
  private num2: number = 0;

  generateCaptcha(): { question: string; answer: number } {
    this.num1 = Math.floor(Math.random() * 10) + 1;
    this.num2 = Math.floor(Math.random() * 10) + 1;
    return { question: `${this.num1} + ${this.num2} =`, answer: this.num1 + this.num2 };
  }
// generateCaptcha() {
//   const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
//   const numbers = '0123456789';
//   const symbols = '!@#$%^&*';
//   const allChars = letters + numbers + symbols;
//   let code = '';

//   code += letters[Math.floor(Math.random() * letters.length)];
//   code += numbers[Math.floor(Math.random() * numbers.length)];
//   code += symbols[Math.floor(Math.random() * symbols.length)];

//   for (let i = 3; i < 8; i++) {
//     code += allChars[Math.floor(Math.random() * allChars.length)];
//   }

//   code = code.split('').sort(() => Math.random() - 0.5).join('');

//   return {
//     question: code,
//     answer: code
//   };
// }




}
